// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./TourComparisonCardStyles";
// @otg-one/ui_components/components
import { Typography, } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// @otg-one/ui_components/icons
import { ArrowHeadRight } from "../../icons";
import { ArrowRight, Clock, Close, Location } from "../../sap_icons";
export const TourComparisonCard = (props) => {
    const classes = useStyles(props);
    const { driverName, tourNumber, vehiclePlate, startingPoint, destination, duration, distance, date, isDeleteable, isCompared } = props;
    return (React.createElement("div", { className: classes.root },
        isCompared && (React.createElement("div", { className: classes.ribbon })),
        React.createElement("div", { className: classes.flexSpaceBetween, style: { height: 24 } },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM, size: 14, color: Color.neutral[500] }, `${driverName}`),
            !isCompared ? (React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 12, color: Color.neutral[400] }, `${date}`)) : (React.createElement(Close, { className: classes.close }))),
        React.createElement("div", { className: classes.flexStart },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 20, color: Color.neutral[600] }, `${tourNumber}`),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 20, color: Color.neutral[600], style: { paddingLeft: 5 } }, `(${vehiclePlate})`)),
        React.createElement("div", { className: classes.flexStart, style: { padding: '2px 0px' } },
            React.createElement("div", { className: classes.flexStart },
                React.createElement(Location, { className: classes.location }),
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[600], size: 12 }, `${startingPoint}`)),
            React.createElement(ArrowRight, { className: classes.rightArrow }),
            React.createElement("div", { className: classes.flexStart },
                React.createElement(Location, { className: classes.location }),
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[600], size: 12 }, `${destination}`))),
        React.createElement("div", { className: classes.timeInformation },
            React.createElement(Clock, { className: classes.clock }),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[500], size: 14, style: { marginLeft: 5 } }, `${duration}`),
            React.createElement(ArrowHeadRight, { className: classes.arrowHeadRight }),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[500], size: 14 }, `${distance}`))));
};
TourComparisonCard.defaultProps = {
    startingPoint: 'Starting Point',
    destination: 'Destination',
    driverName: 'Fahrer Name',
    tourNumber: 'TOURNUM',
    vehiclePlate: 'VECHPLATE',
    date: '1 Jan 2021',
    duration: '1 Hours 23 Minutes',
    distance: '123 km',
    color: Color.primary[300],
    isDeleteable: false,
    isCompared: false
};
export default React.memo(TourComparisonCard);
